import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import { toast } from "react-toastify";

const PinMessageModal = ({ open, onClose, message, ticketId }) => {
  const [durationSeconds, setDurationSeconds] = useState("604800");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!message?.id || !ticketId) return;

    setLoading(true);
    try {
      const { data } = await api.post(`/messages/${encodeURIComponent(message.id)}/pin`, {
        ticketId,
        pinned: true,
        durationSeconds: Number(durationSeconds),
      });
      if (data.synced) {
        toast.success(i18n.t("messagePin.synced"));
      } else {
        toast.warn(i18n.t("messagePin.localOnly"));
      }
      onClose();
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{i18n.t("messagePin.title")}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          {i18n.t("messagePin.description")}
        </Typography>
        <FormControl component="fieldset">
          <RadioGroup
            value={durationSeconds}
            onChange={event => setDurationSeconds(event.target.value)}
          >
            <FormControlLabel value="86400" control={<Radio color="primary" />} label={i18n.t("messagePin.oneDay")} />
            <FormControlLabel value="604800" control={<Radio color="primary" />} label={i18n.t("messagePin.sevenDays")} />
            <FormControlLabel value="2592000" control={<Radio color="primary" />} label={i18n.t("messagePin.thirtyDays")} />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {i18n.t("messagePin.cancel")}
        </Button>
        <Button onClick={submit} disabled={loading} color="primary" variant="contained">
          {i18n.t("messagePin.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PinMessageModal;
